<template>
  <div class="content-box">
    <div class="tree-list heitani">
      <img
        :src="
          detail.coverImage
            ? baseUrl + detail.coverImage
            : '/static/detail/readbook.jpg'
        "
      />
    </div>
    <div class="select-content flex-grow">
      <div>
        <div class="titlebox">
          <div class="bookname">{{ detail.bookName }}</div>
          <div style="display: flex">
            <div class="addshudan" @click.stop="addReadListBox(detail.bookId)">
              加入书单
            </div>
            <div
              class="readonline"
              @click="
                $router.push({
                  name: 'Read',
                  query: {
                    bookId: detail.bookId,
                    bookName: detail.bookName,
                  },
                })
              "
            >
              在线阅读
            </div>
          </div>
        </div>
        <p><span>其他题名：</span>{{ detail.bookName }}</p>
        <div style="display: flex">
          <span>责 任 者：</span>
          <ul v-for="(w, key, i) in detail.writerarr" :key="i">
            <li v-if="i != 0">，</li>
            <li v-for="(ww, ii) in w" :key="ii">
              <i v-if="ii != 0">、</i>
              <i v-if="ww.writerDynastyName">[{{ ww.writerDynastyName }}]</i
              ><i class="cursor" @click="linkdialog(1, ww)">{{
                ww.writerName
              }}</i
              ><i v-if="key != 'null' && ii + 1 == w.length">{{ key }}</i>
            </li>
          </ul>
        </div>
        <p><span>分 类：</span> {{ detail.categoryName }}</p>
        <p><span>版 本：</span>清乾隆武英殿木活字印武英殿聚珍版书本</p>
      </div>
      <div class="line"></div>

      <div class="searchbox">
        <div slot="title">
          <!-- <h2 style="margin: 0; padding: 0; text-align: left">
            {{ detail.bookName }}
          </h2> -->
          <div class="dialog-title">
            <!-- <div class="dialogimg">
              <img src="/static/icon/dialogo.png" alt="" />
            </div> -->

            <!-- <span class="dialogtitle">目録</span> -->
            <div class="menuimg">
              <img
                style="height: 18px; margin-top: 10px"
                src="/static/detail/menu.png"
                alt=""
              />
              <div>
                <el-input
                  placeholder="搜索本书内容"
                  prefix-icon="el-icon-search"
                  v-model="input2"
                >
                </el-input>
              </div>
            </div>
            <!-- <div class="line"></div> -->
          </div>
        </div>
        <div
          ref="treebox"
          class="treebox wrapper"
          style="height: 70vh; overflow: auto"
        >
          <!-- <h3 class="mulutitle">目録</h3> -->
          <el-tree
            node-key="catalogId"
            :data="mulu"
            :props="defaultProps"
            empty-text="该书暂无目录数据"
          >
            <span
              slot-scope="{ node, data, ed }"
              v-html="data.catalogName"
              @click="gotoBookDetail(data, node, ed)"
            >
            </span>
          </el-tree>
        </div>
        <el-backtop target=".treebox">
          <div class="backtopbox">
            <img
              style="width: 100%; height: 100%"
              src="/static/icon/top.jpg"
              alt=""
            /></div
        ></el-backtop>
        <!-- <p class="searchtitle">搜索结果列表</p>
        <p>
          1.霍州<span>李白</span>先生管语诸生日:
          [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
        </p>
        <p>
          2.始至，郡中有粤行者，得<span>李白</span>雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。
        </p>
        <p>
          1.霍州<span>李白</span>先生管语诸生日:
          [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
        </p>
        <p>
          2.始至，郡中有粤行者，得<span>李白</span>雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。
        </p>
        <p>
          1.霍州<span>李白</span>先生管语诸生日:
          [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
        </p>
        <p>
          2.始至，郡中有粤行者，得<span>李白</span>雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。
        </p>
        <p>
          1.霍州<span>李白</span>先生管语诸生日:
          [不厥，教不倦，怒不，遇不贰，不挟贵，不挟管，曹夫子之盛德也
        </p>
        <p>
          2.始至，郡中有粤行者，得<span>李白</span>雪，同升谱席。久而愈敬，生悦服。王寅，调蒲州掌正。
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
import {
  getPdfImages,
  // getCatalogImages,
  getBookCatalogue,
  getBookDetail,
  addFavordData,
  getFavorStatus,
  deleteFavor,
} from "@/api/api"
// import SocialSharing from "vue-social-share"
// import EchartGx from "@/components/echart-gxnew.vue"
import "./share/client.css"
export default {
  name: "bookDetail",
  components: {
    // SocialSharing,
    // EchartGx
  },
  data () {
    return {
      input2: "",
      activewriter: "",//查询作者
      writerIds: [],//作者或校验Id
      copierIds: [],//作者或校验Id
      mulu: [],
      defaultProps: {
        children: 'children',
        label: 'catalogName'
      },
      dialogVisible: false,
      linkVisible: false,//关系图弹窗
      url: "/static/icon/detail.png",
      srcList: [],
      // pdfList: [],
      detail: {},
      isFavor: {},
      baseUrl: window.__baseUrl__,
      test: '<h1 class="ql-indent-1"><strong style="font-size: 18px;" class="ql-font-FangZheng-FanTi">发给回复的后端和﻿</strong></h1>',
      config: {
        // url: "", // 网址，默认使用 window.location.href
        source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: [
          // "qzone",
          "qq",
          "weibo",
          "wechat",

          // "douban",
          // "tencent",
          // "linkedin",
          // "google",
          // "facebook",
          // "twitter",
        ], // 启用的站点
        // disabled: ["google", "facebook", "twitter"], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper: "",
        // "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      dialogVisible4: true,
      // pdfSrc: '',
      // dialogTableVisible: true
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.getDetail()
    this.getFavorData()
    // this.$bus.$on("linkdialog", (type, item) => {
    //   this.linkdialog(type, item)
    // })
  },
  computed: {},
  methods: {
    addReadListBox (id) {
      eventBus.$emit("doChangeTwoVisible", true, id)
    },
    linkdialog (type, item) {
      if (type == 1) {
        // this.writerIds = item.writerId
        // this.copierIds = ''
        this.activewriter = item.writerName
      } else {
        // this.writerIds = ''
        // this.copierIds = item.copierId
        this.activewriter = item.copierName
      }
      this.linkVisible = true

    },
    // gotomulu () {
    //   const el = this.$refs.treebox
    //   el.scrollIntoView({
    //     behavior: 'smooth'
    //   })
    // },
    // viewpdf () {
    //   const querypar = {
    //     pdfSrc: this.pdfSrc
    //   }
    //   const routeData = this.$router.resolve({
    //     //name:"viewer",
    //     path: "/pdfview",
    //     query: querypar,
    //   })
    //   if (this.pdfSrc == '') {
    //     this.$message('还没上传pdf文件')
    //   } else {
    //     window.open(routeData.href, "_blank")
    //   }
    //   // window.open(this.pdfSrc, "_blank")
    // },
    gotoBookDetail (item, node) {
      // console.log(item, node, 'item')

      const url = this.$router.resolve("/viewer?bookId=" + this.detail.bookId + "&bookName=" + this.detail.bookName + "&catalogId=" + item.catalogId + "&juanNum=" + item.juanNum)
      window.open(url.href)

    },
    getDetail () {
      getBookDetail(this.id).then((e) => {
        if (e.code == 200) {
          let d = e.data || {}
          d.summary = d.summary
            ? d.summary.replace(/src="\/prod-api/g, 'src="' + this.baseUrl)
            : ""

          this.detail = d

          this.detail.writerarr = d.writerList.reduce(function (r, a) {
            r[a.writerRole] = r[a.writerRole] || []
            r[a.writerRole].push(a)
            return r
          }, Object.create(null))

          this.detail.writerList && this.detail.writerList.forEach(ele => {
            this.writerIds.push({ writerId: ele.writerId, name: ele.writerName })
          })
          this.detail.copierList && this.detail.copierList.forEach(ele => {
            this.copierIds.push({ copierId: ele.copierId, name: ele.copierName })
          })

        }
        // else {
        //   this.$message.error(e.msg)
        // }


        // this.$set(this.detail, 'writerarr', retarr)

        // this.pdfSrc = this.baseUrl + e.data.pdfPath
        // console.log(this.pdfSrc, 'e3433')
        // this.pdfSrc = this.baseImgPath + this.detail.bookName + '/目录/' + d.data.pdfPath
        // this.srcList = d.catalogImages.map(item=>{
        //   return this.baseUrl + item;
        // });
        //匹配出目录
        // let pattern = /(http?|https):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*png/;
        // let xx=d.summary.match(pattern);
        // if(xx) this.srcList.push(xx[0]);;
        // console.log(xx);
        // console.log(this.detail);
        // 图片目录3/30修改
        // getCatalogImages(this.detail.bookPath).then((e) => {
        //   console.log(e, 'e1')
        //   if (e.data) {
        //     this.srcList = e.data.map(item => {
        //       return this.baseImgPath + this.detail.bookPath + '/目录/' + item
        //     })
        //   } else {
        //     this.srcList = []
        //   }
        // })
        // 树状目录

        // this.activeid = id
        // treeNodeList({ 'parentId': this.detail.bookId, 'nodeType': 'book' }).then(d => {
        //   // console.log(d, 'ddfdf')
        //   this.mulu = d.list

        // })
        getBookCatalogue({ parentId: 0, bookId: this.detail.bookId }).then(

          d => {
            // console.log(d, 'ddfdf')
            this.mulu = d.data

          })


        // getPdfImages(this.detail.bookPath).then((e) => {
        //   console.log(e, 'e2')
        //   if (e.data) {
        //     this.pdfList = e.data.map(item => {
        //       // return this.baseUrl + item;
        //       return this.baseImgPath + 'pdf/' + this.detail.bookPath + '/' + item
        //     })
        //   } else {
        //     this.pdfList = []
        //   }

        // })
      })



    },

    getShareMail () {
      return (
        "mailto:&subject=" + this.detail.bookName + "&body=" + location.href
      )
    },
    addFavordData () {
      if (this.isFavor.isFavor) {
        return deleteFavor(this.isFavor.favorId).then((e) => {
          if (e.code == 200) {
            this.$message.success("已取消收藏")
            this.getFavorData()
          } else {
            this.$message.error(e.msg)
          }
        })
      }
      addFavordData({ bookId: this.id }).then((e) => {
        if (e.code == 200) {
          this.$message.success("收藏成功")
          this.getFavorData()
        } else {
          this.$message.error(e.msg)
        }
      })
    },
    getFavorData () {
      getFavorStatus(this.id).then((res) => {
        this.isFavor = res
      })
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner {
  width: 200px;
  margin-top: 10px;
}
.menuimg {
  display: flex;
  justify-content: space-between;
}
.titlebox {
  display: flex;
  justify-content: space-between;
}
.addshudan {
  width: 88px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  // transform: scaleX(-1) scaleY(-1);
  background: #DBB054;
  border: #DBB054;
  border-radius: 4px;
  font-family: PingFang-SC-Regular;
  font-size: 14px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
}
.readonline {
  width: 88px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #795636;
  border:#795636;
  border-radius: 4px;
  font-family: PingFang-SC-Bold;
  font-size: 14px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  margin-left: 10px;
  cursor: pointer;
}
.searchbox {
  p {
    font-family: PingFang-SC-ExtraLight;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 400;
    span {
      font-family: PingFang-SC-Bold;

      letter-spacing: 0;
      line-height: 14px;
      font-weight: 700;
      background: rgba(255, 110, 91, 0.6);
      border-radius: 2px;
    }
  }
}
.content-box {
  width: 100%;
  display: -webkit-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: auto;
  padding: 16px 10px;
  background: rgb(244, 240, 232);
  .lefthead {
    height: 64px;
    font-family: PingFang-SC-Bold;
    font-size: 16px;
    color: #002f38;
    letter-spacing: 0;
    text-align: center;
    line-height: 64px;
    font-weight: 700;
    border-bottom: 1px solid #eeeeee;
    span {
      display: inline-block;
      border-bottom: 2px solid #2c7e8d;
    }
  }
}
.content-box .tree-list {
  // margin-right: 16px;
  // padding-left: 24px;
  // padding-right: 15px;
  padding: 20px;
  width: 300px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  min-height: 86vh;
  img {
    width: 100%;
    height: auto;
  }
  .leftpro {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    line-height: 2.5;
    font-weight: 400;
    padding: 0 10px;
    cursor: pointer;
  }
  .activepro {
    background: #2c7e8d;
    border-radius: 4px;
    color: #ffffff;
  }
}

.content-box .select-content {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 1.4rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  min-height: 86vh;
  background: #fff;
  .bookname {
    font-family: PingFang-SC-Bold;
    font-size: 16px;
    color: #002f38;
    letter-spacing: 0;
    line-height: 2;
    font-weight: 700;
  }
  p,
  ul,
  li,
  span {
    span {
      font-weight: 400;
    }
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 1.5;
    font-weight: 500;
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #eeeeee;
  border-radius: 4px;
}
.el-input__inner {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookDetail/index.vue